import { computed, unref, type MaybeRef } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { seasonAPI, type ClubHomeEvent } from '@/api'

export const isDevelopmentProgram = (eventType?: string) =>
  ['developmentprogram', 'devprogram', 'devstream'].includes(String(eventType || '').toLowerCase())

// The home/context bundles do not currently include eventType. The normalized
// season catalogue is authoritative and shared with the event switcher.
export function useSeasonEvents(clubId: MaybeRef<string>, seasonId: MaybeRef<string>) {
  const query = useQuery({
    queryKey: computed(() => ['seasonEvents', unref(clubId), unref(seasonId)]),
    queryFn: ({ signal }) => seasonAPI.loadSeasonHome(unref(seasonId), unref(clubId), signal),
    enabled: computed(() => !!unref(clubId) && !!unref(seasonId)),
  })
  const events = computed(() => {
    const byId = new Map<string, ClubHomeEvent>()
    for (const event of query.data.value?.events || []) byId.set(event.id, event)
    for (const event of query.data.value?.developmentPrograms || []) {
      byId.set(event.id, { ...event, eventType: 'developmentProgram' })
    }
    return [...byId.values()]
  })
  return { query, events }
}
